import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-wams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { Validators } from "@angular/forms";
import { CreateApplicationLocationWamsConstants } from "./create-application-location-wams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { debounceTime } from "rxjs";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { DatePipe } from "@angular/common";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { AppConfig } from "../../../../app.config";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
import { AlertType } from "../../../../shared/models/alert";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { take } from "rxjs/operators";
let CreateApplicationLocationWamsComponent = class CreateApplicationLocationWamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapTools;
    datePipe;
    changeDetectorRefs;
    searchApplicationsService;
    active;
    locationForm;
    descriptionLabel1 = CreateApplicationLocationWamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationWamsConstants.DESCRIPTION_LABEL_2;
    layerReference = CreateApplicationLocationWamsConstants.LAYER_REF;
    showOnlyPropertyAndZoningLayers = false;
    resubmissionForm;
    descriptionFormControlName = CreateApplicationLocationWamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationLocationWamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    clientReferenceNumberFormControlName = CreateApplicationLocationWamsConstants.CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    applicantTelecommunicationLicenseNumberFormControlName = CreateApplicationLocationWamsConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME;
    scopeOfWorkFormControlName = CreateApplicationLocationWamsConstants.SCOPE_OF_WORK_FORM_CONTROL_NAME;
    estimatedConstructionCostFormControlName = CreateApplicationLocationWamsConstants.ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME;
    applicationFeeFormControlName = CreateApplicationLocationWamsConstants.APPLICATION_FEE_FORM_CONTROL_NAME;
    constructionPeriodFormControlName = CreateApplicationLocationWamsConstants.CONSTRUCTION_PERIOD_FORM_CONTROL_NAME;
    servicesFormControlName = CreateApplicationLocationWamsConstants.SERVICES_FORM_CONTROL_NAME;
    proposedStartDateFormControlName = CreateApplicationLocationWamsConstants.PROPOSED_START_DATE_FORM_CONTROL_NAME;
    proposedEndDateFormControlName = CreateApplicationLocationWamsConstants.PROPOSED_END_DATE_FORM_CONTROL_NAME;
    laneClosureIsRequiredFormControlName = CreateApplicationLocationWamsConstants.LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME;
    laneClosureExtentFormControlName = CreateApplicationLocationWamsConstants.LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME;
    constructionPeriodUnitsFormControlName = CreateApplicationLocationWamsConstants.CONSTRUCTION_PERIOD_UNITS_FORM_CONTROL_NAME;
    electricalServicesFormControlName = CreateApplicationLocationWamsConstants.ELECTRICAL_SERVICES_FORM_CONTROL_NAME;
    actualStartDateFormControlName = CreateApplicationLocationWamsConstants.ACTUAL_START_DATE_FORM_CONTROL_NAME;
    actualEndDateFormControlName = CreateApplicationLocationWamsConstants.ACTUAL_END_DATE_FORM_CONTROL_NAME;
    applicantFormControlName = CreateApplicationLocationWamsConstants.APPLICANT_FORM_CONTROL_NAME;
    applicantAgentFormControlName = CreateApplicationLocationWamsConstants.APPLICANT_AGENT_FORM_CONTROL_NAME;
    implementingAgentFormControlName = CreateApplicationLocationWamsConstants.IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationLocationWamsConstants.ENGINEER_FORM_CONTROL_NAME;
    responsibleContractorFormControlName = CreateApplicationLocationWamsConstants.RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME;
    markImplementingAgentAsNotApplicableFormControlName = CreateApplicationLocationWamsConstants.MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markEngineerAsNotApplicableFormControlName = CreateApplicationLocationWamsConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    markContractorAsNotApplicableFormControlName = CreateApplicationLocationWamsConstants.MARK_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    isResubmissionLabel = CreateApplicationLocationWamsConstants.IS_RESUBMISSION_LABEL;
    previousReferenceNumberLabel = CreateApplicationLocationWamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    verifyLabel = CreateApplicationLocationWamsConstants.VERIFY_LABEL;
    isResubmissionFormControlName = CreateApplicationLocationWamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = CreateApplicationLocationWamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    validationMessages = CreateApplicationLocationWamsConstants.VALIDATION_MESSAGES;
    verificationMessage = CreateApplicationLocationWamsConstants.RESUBMISSION_VERIFICATION_MESSAGE;
    verificationMessageFailure = CreateApplicationLocationWamsConstants.RESUBMISSION_VERIFICATION_MESSAGE_FAILURE;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    isResubmissionOptions = [];
    isResubmission = false;
    isVerified = false;
    supportResubmissions = false;
    mapComponent;
    sketch;
    selectedGraphic = null;
    isMapLoaded = false;
    selectedApplicationLocationWamsSubscription;
    clearLayerGraphicsSubjectSubscription;
    detailsFormFormGroupName = CreateApplicationLocationWamsConstants.DETAILS_FORM_GROUP;
    locationFormGroupName = CreateApplicationLocationWamsConstants.LOCATION_FORM_GROUP_NAME;
    applicantFormGroupName = CreateApplicationLocationWamsConstants.APPLICANT_FORM_GROUP_NAME;
    applicantAgentFormGroupName = CreateApplicationLocationWamsConstants.APPLICANT_AGENT_FORM_GROUP_NAME;
    professionalBodiesFormGroupName = CreateApplicationLocationWamsConstants.PROFESSIONAL_BODIES_FORM_GROUP_NAME;
    noteFormFormGroupName = CreateApplicationLocationWamsConstants.NOTE_FORM_GROUP_NAME;
    documentationFormGroupName = CreateApplicationLocationWamsConstants.DOCUMENTATION_FORM_GROUP_NAME;
    notesFormFormControlName = CreateApplicationLocationWamsConstants.NOTE_FORM_CONTROL_NAME;
    acceptResubmissionDisclaimer = false;
    acceptDisclaimerForm;
    resubmissionDisclaimerTitle = "";
    resubmissionDisclaimerContent = "";
    acceptFormControlLabel = CreateApplicationLocationWamsConstants.ACCEPT_LABEL;
    titleLabelMessage = CreateApplicationLocationWamsConstants.RESUBMISSION_DISCLAIMER_TITLE_LABEL_MESSAGE;
    contentLabelMessage = CreateApplicationLocationWamsConstants.RESUBMISSION_DISCLAIMER_CONTENT_LABEL_MESSAGE;
    acceptFormControlName = CreateApplicationLocationWamsConstants.ACCEPT_FORM_CONTROL_NAME;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapTools, datePipe, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapTools = mapTools;
        this.datePipe = datePipe;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.resubmissionDisclaimerTitle = AppConfig.settings.resubmissionDisclaimer.w.title;
            this.resubmissionDisclaimerContent = AppConfig.settings.resubmissionDisclaimer.w.content;
            if (this.resubmissionDisclaimerTitle === "") {
                this.resubmissionDisclaimerTitle = this.titleLabelMessage;
            }
            if (this.resubmissionDisclaimerContent === "") {
                this.resubmissionDisclaimerContent = this.contentLabelMessage;
            }
        }
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.setupSubscribers();
        this.getLookups();
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
        else {
            // user won't be accepting disclaimer so we can clear validation
            this.locationForm.get(this.isResubmissionFormControlName).clearValidators();
            this.locationForm.get(this.isResubmissionFormControlName).updateValueAndValidity();
            this.locationForm.updateValueAndValidity();
        }
    }
    onToggleAccept(event) {
        const accept = event.target.checked;
        if (!this.aflaModuleStrategyService.previousApplication) {
            this.appController.showMessage("Please validate an application before accepting disclaimer", AlertType.Warning);
            this.locationForm.get(this.acceptFormControlName).setValue(false);
            this.acceptResubmissionDisclaimer = false;
            return;
        }
        this.acceptResubmissionDisclaimer = accept;
        this.aflaModuleStrategyService.previousApplication.acceptResubmissionDisclaimer = accept;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.mapTools.expandWidget("drawTool");
        this.sketch.create("polygon");
        this.sketch.on("create", (event) => {
            if (event.state === "complete") {
                this.selectedGraphic = event.graphic;
                this.locationForm.get("selectedGraphic").setValue(this.selectedGraphic);
                if (event.graphic.geometry.type === "point") {
                    this.locationForm.get("centroid").setValue(event.graphic.geometry);
                    this.locationForm.get("polygon").setValue(null);
                    this.locationForm.get("polyline").setValue(null);
                }
                else {
                    const proxyUrl = ApiProxyConstants.URL;
                    const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                    const url = `${proxyUrl}?${gpToolUrl}`;
                    const formData = new FormData();
                    formData.append("f", "json");
                    formData.append("geometryJSON", JSON.stringify(event.graphic.geometry));
                    this.applicationCreateService.getTrueCentroid(url, formData)
                        .pipe(take(1))
                        .subscribe({
                        next: (trueCentroidResponse) => {
                            this.locationForm.get("centroid").setValue(trueCentroidResponse.results[0].value);
                            this.locationForm.markAsTouched();
                            if (event.graphic.geometry.type === "polygon") {
                                this.locationForm.get("polygon").setValue(event.graphic.geometry);
                            }
                            else if (event.graphic.geometry.type === "polyline") {
                                this.locationForm.get("polyline").setValue(event.graphic.geometry);
                            }
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage(CreateApplicationLocationWamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                        }
                    });
                }
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
        if (this.locationForm.get("selectedGraphic").value !== null) {
            this.selectedGraphic = this.locationForm.get("selectedGraphic").value;
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.selectedGraphic.geometry)], "Draw Tool Layer");
        }
    }
    loadMetadata(stepMeta) {
    }
    onIsResubmissionChanged(event) {
        const element = event.target?.value;
        this.acceptResubmissionDisclaimer = null;
        this.resetAllFormGroups();
        this.aflaModuleStrategyService.form.get(this.locationFormGroupName).reset();
        this.aflaModuleStrategyService.resetForm();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.isResubmission = true;
            this.aflaModuleStrategyService.previousApplication = null;
            // clear resubmission form
            this.locationForm.get(this.previousReferenceNumberFormControlName).enable();
            this.locationForm.get(this.previousReferenceNumberFormControlName).reset();
            this.locationForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.locationForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
            this.locationForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.acceptResubmissionDisclaimer = false;
        }
        else {
            this.aflaModuleStrategyService.previousApplication = null;
            this.locationForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.locationForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.locationForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
            this.locationForm.get(this.previousReferenceNumberFormControlName).reset();
            this.locationForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.locationForm.get(this.previousReferenceNumberFormControlName).disable();
            this.isResubmission = false;
            this.acceptResubmissionDisclaimer = false;
        }
        // clear maps
        this.mapComponent.removeGraphicsFromMap(this.layerReference);
        this.mapTools.sketchGraphicsLayer.removeAll();
        this.locationForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onVerifyReferenceNumberClicked() {
        const previousReferenceNumber = this.locationForm.get(this.previousReferenceNumberFormControlName).value;
        if (previousReferenceNumber !== null || previousReferenceNumber !== "") {
            const params = {
                previousReferenceNumber,
                isResubmission: this.isResubmission,
                moduleId: this.appController.selectedModuleID,
                $orderby: "jobid",
                $expand: `attachments, applicationLines, applicationPolygons, notes, contractor($expand=groups),engineer($expand=groups),implementingAgent($expand=groups),applicant($expand=groups),applicantAgent($expand=groups)`
            };
            this.aflaModuleStrategyService.previousApplication = null;
            this.aflaModuleStrategyService.verifyResubmissionReferenceNumberObservable(params).pipe(take(1)).subscribe({
                next: results => {
                    let latestApplication;
                    if (results) {
                        if (results.value.length > 0) {
                            latestApplication = results.value[results.value.length - 1];
                        }
                        else {
                            latestApplication = results.value[0];
                        }
                        this.isVerified = true;
                        this.getVerifiedApplication(latestApplication.jobId, this.appController.selectedModuleID);
                        this.appController.showMessage(this.verificationMessage, AlertType.Success);
                    }
                    else {
                        this.appController.showMessage(this.verificationMessageFailure, AlertType.Warning);
                        this.isVerified = false;
                        this.changeDetectorRefs.detectChanges();
                    }
                },
                error: err => {
                    if (this.isString(err.error)) {
                        this.appController.showMessage(err.error, AlertType.Warning);
                    }
                    else {
                        this.appController.handleServerErrorMessage("verify resubmission", err, CRUDOperation.Get);
                    }
                    this.isVerified = false;
                    this.changeDetectorRefs.detectChanges();
                }
            });
        }
        else {
            this.appController.showMessage("Please enter a valid reference number", AlertType.Warning);
        }
    }
    getVerifiedApplication(jobId, moduleId) {
        const params = {
            $filter: `jobId eq ${jobId} and moduleId eq ${moduleId}`,
            $expand: `attachments, applicationLines, applicationPolygons, notes, contractor($expand=groups),engineer($expand=groups),implementingAgent($expand=groups),applicant($expand=groups),applicantAgent($expand=groups)`
        };
        this.aflaModuleStrategyService.getAllApplicationsQuery(params).pipe(debounceTime(1000)).pipe(take(1)).subscribe((returnValue) => {
            const application = this.cleanPreviousApplicationData(returnValue.value[0]);
            const currentDisclaimerStatus = this.locationForm.get(this.acceptFormControlName).value;
            this.selectedApplication = application;
            // this.selectedApplicationService.setSelectedApplication(application);
            this.aflaModuleStrategyService.previousApplication = application;
            this.locationForm.get(this.acceptFormControlName).setValue(currentDisclaimerStatus);
            this.acceptResubmissionDisclaimer = currentDisclaimerStatus;
            this.isVerified = true;
            // set details form
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.descriptionFormControlName).setValue(application.description);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.applicationTypeFormControlName).setValue(application.applicationType);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.clientReferenceNumberFormControlName).setValue(application.clientReferenceNumber);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.applicantTelecommunicationLicenseNumberFormControlName).setValue(application.licenceNumber);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.scopeOfWorkFormControlName).setValue(application.scopeOfWork);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.estimatedConstructionCostFormControlName).setValue(application.estimatedCost);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.applicationFeeFormControlName).setValue(application.applicationFee);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.constructionPeriodFormControlName).setValue(application.constructionPeriod);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.constructionPeriodUnitsFormControlName).setValue(application.constructionPeriodUnits);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.proposedStartDateFormControlName).setValue(this.datePipe.transform(application.proposedStartDate, "yyyy-MM-dd"));
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.proposedEndDateFormControlName).setValue(this.datePipe.transform(application.proposedEndDate, "yyyy-MM-dd"));
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.laneClosureIsRequiredFormControlName).setValue(application.laneClosureRequired);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.laneClosureExtentFormControlName).setValue(application.laneClosureExtent);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.electricalServicesFormControlName).setValue(application.electricalServices);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.servicesFormControlName).setValue(application.services);
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.actualStartDateFormControlName).setValue(this.datePipe.transform(application.actualStartDate, "yyyy-MM-dd"));
            this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).get(this.actualEndDateFormControlName).setValue(this.datePipe.transform(application.actualEndDate, "yyyy-MM-dd"));
            // set applicant form data
            if (application.applicant[0] !== null) {
                this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).get(this.applicantFormControlName).setValue(application.applicant[0]);
            }
            // set applicant Agent form data
            if (application.applicantAgent[0] !== null) {
                this.aflaModuleStrategyService.form.get(this.applicantAgentFormGroupName).get(this.applicantAgentFormControlName).setValue(application.applicantAgent[0]);
            }
            // set implementingAgent
            if (application.implementingAgent[0] !== null) {
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.implementingAgentFormControlName).setValue(application.implementingAgent[0]);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.markImplementingAgentAsNotApplicableFormControlName).setValue(true);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.implementingAgentFormControlName).enable();
            }
            // set engineer
            if (application.engineer[0] !== null) {
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.engineerFormControlName).setValue(application.engineer[0]);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.markEngineerAsNotApplicableFormControlName).setValue(true);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.engineerFormControlName).enable();
            }
            // set contractor
            if (application.contractor[0] !== null) {
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.responsibleContractorFormControlName).setValue(application.contractor[0]);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.markContractorAsNotApplicableFormControlName).setValue(true);
                this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).get(this.responsibleContractorFormControlName).enable();
            }
            if (application.applicationLines && application.applicationLines?.length > 0) {
                // this.createApplicationService.applicationData = application;
                const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.shape, 102100);
                const centroid = JsonUtils.fromJSON(centroidGeometryArc);
                this.aflaModuleStrategyService.form.get(this.locationFormGroupName).get("centroid").setValue(centroid);
                const polylineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.applicationLines[0].shape, 102100);
                const polyline = JsonUtils.fromJSON(polylineGeometryArc);
                this.aflaModuleStrategyService.form.get("polyline").setValue(polyline);
                this.aflaModuleStrategyService.form.get("polylineDto").setValue(application.applicationLines[0]);
                this.syncMapGeometries();
            }
            if (application.applicationPolygons && application.applicationPolygons?.length > 0) {
                // this.createApplicationService.applicationData = application;
                const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.shape, 102100);
                const centroid = JsonUtils.fromJSON(centroidGeometryArc);
                this.aflaModuleStrategyService.form.get(this.locationFormGroupName).get("centroid").setValue(centroid);
                const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.applicationPolygons[0].shape, 102100);
                const polygon = JsonUtils.fromJSON(polygonGeometryArc);
                this.aflaModuleStrategyService.form.get(this.locationFormGroupName).get("polygon").setValue(polygon);
                this.aflaModuleStrategyService.form.get(this.locationFormGroupName).get("polygonDto").setValue(application.applicationPolygons[0]);
                this.syncMapGeometries();
            }
            // set notes
            if (application.notes && application.notes?.length > 0) {
                this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName)?.get(this.notesFormFormControlName).setValue(application.notes[0]?.note);
            }
        });
    }
    cleanPreviousApplicationData(application) {
        const app = {};
        if (application) {
            app.id = 0;
            app.jobId = application.jobId;
            app.createdUser = application.createdUser;
            app.createdDate = application.createdDate;
            app.previousReferenceNumber = application.previousReferenceNumber;
            app.referenceNumber = application.referenceNumber;
            app.services = application.services;
            app.constructionPeriodUnits = application.constructionPeriodUnits;
            app.applicationType = application.applicationType;
            app.description = application.description;
            app.clientReferenceNumber = application.clientReferenceNumber;
            app.licenceNumber = application.licenceNumber;
            app.scopeOfWork = application.scopeOfWork;
            app.estimatedCost = application.estimatedCost;
            app.constructionPeriod = application.constructionPeriod;
            app.electricalServices = application.electricalServices;
            app.applicationFee = application.applicationFee;
            app.shape = application.shape;
            app.wkid = application.wkid;
            app.proposedStartDate = application.proposedStartDate;
            app.proposedEndDate = application.proposedEndDate;
            app.actualStartDate = application.actualStartDate;
            app.actualEndDate = application.actualEndDate;
            app.laneClosureRequired = application.laneClosureRequired;
            app.laneClosureExtent = application.laneClosureExtent;
            app.moduleId = application.moduleId;
            app.resubmissionStartDate = application.resubmissionStartDate;
            app.isResubmission = true;
            app.deleted = false;
            app.implementingAgentNa = application.implementingAgentNa;
            app.engineerNa = application.engineerNa;
            app.contractorNa = application.contractorNa;
            app.applicantAgentNa = application.applicantAgentNa;
            app.portalV1Username = application.portalV1Username;
            if (this.locationForm.get(this.isResubmissionFormControlName).value === SharedConstants.YES_NO_ENUM.Yes) {
                app.isResubmission = true;
                app.previousReferenceNumber = this.locationForm.get(this.previousReferenceNumberFormControlName).value ?? null;
            }
            else {
                app.isResubmission = false;
                this.locationForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            }
        }
        if (application.applicationLines) {
            const applicationLinesArray = [];
            application.applicationLines.forEach(applicationLineItem => {
                const applicationLine = {};
                applicationLine.id = 0;
                applicationLine.shape = applicationLineItem.shape;
                applicationLine.wkid = applicationLineItem.wkid;
                applicationLine.deleted = applicationLineItem.deleted;
                applicationLinesArray.push(applicationLine);
            });
            app.applicationLines = applicationLinesArray;
        }
        if (application.applicationPolygons) {
            const applicationPolygonsArray = [];
            application.applicationPolygons.forEach(applicationPolygonItem => {
                const applicationPolygon = {};
                applicationPolygon.id = 0;
                applicationPolygon.shape = applicationPolygonItem.shape;
                applicationPolygon.wkid = applicationPolygonItem.wkid;
                applicationPolygon.deleted = applicationPolygonItem.deleted;
                applicationPolygonsArray.push(applicationPolygon);
            });
            app.applicationPolygons = applicationPolygonsArray;
        }
        if (application.applicant) {
            let applicants = {};
            applicants = [];
            application.applicant.forEach(savedApplicant => {
                const applicant = {};
                applicant.clientVatNumber = savedApplicant.clientVatNumber;
                applicant.setRecipient = savedApplicant.setRecipient;
                applicant.fullName = savedApplicant.fullName;
                applicant.id = 0;
                applicant.moduleId = savedApplicant.moduleId;
                applicant.name = savedApplicant.name;
                applicant.surname = savedApplicant.surname;
                applicant.telephone = savedApplicant.telephone;
                applicant.email = savedApplicant.email;
                applicant.defaultCommunicationMethod = savedApplicant.defaultCommunicationMethod;
                applicant.postalAddress = savedApplicant.postalAddress;
                applicant.designation = savedApplicant.designation;
                applicant.organisation = savedApplicant.organisation;
                applicant.streetAddress = savedApplicant.streetAddress;
                applicant.homePhone = savedApplicant.homePhone;
                applicant.idNumber = savedApplicant.idNumber;
                applicant.organisationRegistrationNumber = savedApplicant.organisationRegistrationNumber;
                applicant.representative = savedApplicant.representative;
                applicant.fax = savedApplicant.fax;
                applicant.maritalStatus = savedApplicant.maritalStatus;
                applicant.relativesFullName = savedApplicant.relativesFullName;
                applicant.relativesContactNumber = savedApplicant.relativesContactNumber;
                applicant.relativesAddress = savedApplicant.relativesAddress;
                applicant.employmentStatus = savedApplicant.employmentStatus;
                applicant.employersName = savedApplicant.employersName;
                applicant.employersContactNumber = savedApplicant.employersContactNumber;
                applicant.employersAddress = savedApplicant.employersAddress;
                applicant.cellphone = savedApplicant.cellphone;
                applicant.streetSuburb = savedApplicant.streetSuburb;
                applicant.streetCity = savedApplicant.streetCity;
                applicant.streetProvince = savedApplicant.streetProvince;
                applicant.streetCode = savedApplicant.streetCode;
                applicant.postalSuburb = savedApplicant.postalSuburb;
                applicant.postalCity = savedApplicant.postalCity;
                applicant.postalProvince = savedApplicant.postalProvince;
                applicant.postalCode = savedApplicant.postalCode;
                applicant.postalCountry = savedApplicant.postalCountry;
                applicant.streetCountry = savedApplicant.streetCountry;
                applicant.professionalBody = savedApplicant.professionalBody;
                applicant.professionalBodyRegNum = savedApplicant.professionalBodyRegNum;
                applicant.consolidatedGroup = savedApplicant.consolidatedGroup;
                applicant.emailField = savedApplicant.emailField;
                let groups = {};
                groups = [];
                savedApplicant.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicant.groups = groups;
                applicants.push(applicant);
            });
            app.applicant = applicants;
        }
        if (application.applicantAgent) {
            let applicantAgents = {};
            applicantAgents = [];
            application.applicantAgent.forEach(savedApplicantAgent => {
                const applicantAgent = {};
                applicantAgent.clientVatNumber = savedApplicantAgent.clientVatNumber;
                applicantAgent.setRecipient = savedApplicantAgent.setRecipient;
                applicantAgent.fullName = savedApplicantAgent.fullName;
                applicantAgent.id = 0;
                applicantAgent.moduleId = savedApplicantAgent.moduleId;
                applicantAgent.name = savedApplicantAgent.name;
                applicantAgent.surname = savedApplicantAgent.surname;
                applicantAgent.telephone = savedApplicantAgent.telephone;
                applicantAgent.email = savedApplicantAgent.email;
                applicantAgent.defaultCommunicationMethod = savedApplicantAgent.defaultCommunicationMethod;
                applicantAgent.postalAddress = savedApplicantAgent.postalAddress;
                applicantAgent.designation = savedApplicantAgent.designation;
                applicantAgent.organisation = savedApplicantAgent.organisation;
                applicantAgent.streetAddress = savedApplicantAgent.streetAddress;
                applicantAgent.homePhone = savedApplicantAgent.homePhone;
                applicantAgent.idNumber = savedApplicantAgent.idNumber;
                applicantAgent.organisationRegistrationNumber = savedApplicantAgent.organisationRegistrationNumber;
                applicantAgent.representative = savedApplicantAgent.representative;
                applicantAgent.fax = savedApplicantAgent.fax;
                applicantAgent.maritalStatus = savedApplicantAgent.maritalStatus;
                applicantAgent.relativesFullName = savedApplicantAgent.relativesFullName;
                applicantAgent.relativesContactNumber = savedApplicantAgent.relativesContactNumber;
                applicantAgent.relativesAddress = savedApplicantAgent.relativesAddress;
                applicantAgent.employmentStatus = savedApplicantAgent.employmentStatus;
                applicantAgent.employersName = savedApplicantAgent.employersName;
                applicantAgent.employersContactNumber = savedApplicantAgent.employersContactNumber;
                applicantAgent.employersAddress = savedApplicantAgent.employersAddress;
                applicantAgent.cellphone = savedApplicantAgent.cellphone;
                applicantAgent.streetSuburb = savedApplicantAgent.streetSuburb;
                applicantAgent.streetCity = savedApplicantAgent.streetCity;
                applicantAgent.streetProvince = savedApplicantAgent.streetProvince;
                applicantAgent.streetCode = savedApplicantAgent.streetCode;
                applicantAgent.postalSuburb = savedApplicantAgent.postalSuburb;
                applicantAgent.postalCity = savedApplicantAgent.postalCity;
                applicantAgent.postalProvince = savedApplicantAgent.postalProvince;
                applicantAgent.postalCode = savedApplicantAgent.postalCode;
                applicantAgent.postalCountry = savedApplicantAgent.postalCountry;
                applicantAgent.streetCountry = savedApplicantAgent.streetCountry;
                applicantAgent.professionalBody = savedApplicantAgent.professionalBody;
                applicantAgent.professionalBodyRegNum = savedApplicantAgent.professionalBodyRegNum;
                applicantAgent.consolidatedGroup = savedApplicantAgent.consolidatedGroup;
                applicantAgent.emailField = savedApplicantAgent.emailField;
                let groups = {};
                groups = [];
                savedApplicantAgent.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicantAgent.groups = groups;
                applicantAgents.push(applicantAgent);
            });
            app.applicantAgent = applicantAgents;
        }
        if (application.implementingAgent) {
            let implementingAgents = {};
            implementingAgents = [];
            application.implementingAgent.forEach(a => {
                const implementingAgent = {};
                implementingAgent.clientVatNumber = a.clientVatNumber;
                implementingAgent.setRecipient = a.setRecipient;
                implementingAgent.fullName = a.fullName;
                implementingAgent.id = 0;
                implementingAgent.moduleId = a.moduleId;
                implementingAgent.name = a.name;
                implementingAgent.surname = a.surname;
                implementingAgent.telephone = a.telephone;
                implementingAgent.email = a.email;
                implementingAgent.defaultCommunicationMethod = a.defaultCommunicationMethod;
                implementingAgent.postalAddress = a.postalAddress;
                implementingAgent.designation = a.designation;
                implementingAgent.organisation = a.organisation;
                implementingAgent.streetAddress = a.streetAddress;
                implementingAgent.homePhone = a.homePhone;
                implementingAgent.idNumber = a.idNumber;
                implementingAgent.organisationRegistrationNumber = a.organisationRegistrationNumber;
                implementingAgent.representative = a.representative;
                implementingAgent.fax = a.fax;
                implementingAgent.maritalStatus = a.maritalStatus;
                implementingAgent.relativesFullName = a.relativesFullName;
                implementingAgent.relativesContactNumber = a.relativesContactNumber;
                implementingAgent.relativesAddress = a.relativesAddress;
                implementingAgent.employmentStatus = a.employmentStatus;
                implementingAgent.employersName = a.employersName;
                implementingAgent.employersContactNumber = a.employersContactNumber;
                implementingAgent.employersAddress = a.employersAddress;
                implementingAgent.cellphone = a.cellphone;
                implementingAgent.streetSuburb = a.streetSuburb;
                implementingAgent.streetCity = a.streetCity;
                implementingAgent.streetProvince = a.streetProvince;
                implementingAgent.streetCode = a.streetCode;
                implementingAgent.postalSuburb = a.postalSuburb;
                implementingAgent.postalCity = a.postalCity;
                implementingAgent.postalProvince = a.postalProvince;
                implementingAgent.postalCode = a.postalCode;
                implementingAgent.postalCountry = a.postalCountry;
                implementingAgent.streetCountry = a.streetCountry;
                implementingAgent.professionalBody = a.professionalBody;
                implementingAgent.professionalBodyRegNum = a.professionalBodyRegNum;
                implementingAgent.consolidatedGroup = a.consolidatedGroup;
                implementingAgent.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                implementingAgent.groups = groups;
                implementingAgents.push(implementingAgent);
            });
            app.implementingAgent = implementingAgents;
        }
        if (application.engineer) {
            let engineers = {};
            engineers = [];
            application.engineer.forEach(a => {
                const engineer = {};
                engineer.clientVatNumber = a.clientVatNumber;
                engineer.setRecipient = a.setRecipient;
                engineer.fullName = a.fullName;
                engineer.id = 0;
                engineer.moduleId = a.moduleId;
                engineer.name = a.name;
                engineer.surname = a.surname;
                engineer.telephone = a.telephone;
                engineer.email = a.email;
                engineer.defaultCommunicationMethod = a.defaultCommunicationMethod;
                engineer.postalAddress = a.postalAddress;
                engineer.designation = a.designation;
                engineer.organisation = a.organisation;
                engineer.streetAddress = a.streetAddress;
                engineer.homePhone = a.homePhone;
                engineer.idNumber = a.idNumber;
                engineer.organisationRegistrationNumber = a.organisationRegistrationNumber;
                engineer.representative = a.representative;
                engineer.fax = a.fax;
                engineer.maritalStatus = a.maritalStatus;
                engineer.relativesFullName = a.relativesFullName;
                engineer.relativesContactNumber = a.relativesContactNumber;
                engineer.relativesAddress = a.relativesAddress;
                engineer.employmentStatus = a.employmentStatus;
                engineer.employersName = a.employersName;
                engineer.employersContactNumber = a.employersContactNumber;
                engineer.employersAddress = a.employersAddress;
                engineer.cellphone = a.cellphone;
                engineer.streetSuburb = a.streetSuburb;
                engineer.streetCity = a.streetCity;
                engineer.streetProvince = a.streetProvince;
                engineer.streetCode = a.streetCode;
                engineer.postalSuburb = a.postalSuburb;
                engineer.postalCity = a.postalCity;
                engineer.postalProvince = a.postalProvince;
                engineer.postalCode = a.postalCode;
                engineer.postalCountry = a.postalCountry;
                engineer.streetCountry = a.streetCountry;
                engineer.professionalBody = a.professionalBody;
                engineer.professionalBodyRegNum = a.professionalBodyRegNum;
                engineer.consolidatedGroup = a.consolidatedGroup;
                engineer.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                engineer.groups = groups;
                engineers.push(engineer);
            });
            app.engineer = engineers;
        }
        if (application.contractor) {
            let contractors = {};
            contractors = [];
            application.contractor.forEach(a => {
                const contractor = {};
                contractor.clientVatNumber = a.clientVatNumber;
                contractor.setRecipient = a.setRecipient;
                contractor.fullName = a.fullName;
                contractor.id = 0;
                contractor.moduleId = a.moduleId;
                contractor.name = a.name;
                contractor.surname = a.surname;
                contractor.telephone = a.telephone;
                contractor.email = a.email;
                contractor.defaultCommunicationMethod = a.defaultCommunicationMethod;
                contractor.postalAddress = a.postalAddress;
                contractor.designation = a.designation;
                contractor.organisation = a.organisation;
                contractor.streetAddress = a.streetAddress;
                contractor.homePhone = a.homePhone;
                contractor.idNumber = a.idNumber;
                contractor.organisationRegistrationNumber = a.organisationRegistrationNumber;
                contractor.representative = a.representative;
                contractor.fax = a.fax;
                contractor.maritalStatus = a.maritalStatus;
                contractor.relativesFullName = a.relativesFullName;
                contractor.relativesContactNumber = a.relativesContactNumber;
                contractor.relativesAddress = a.relativesAddress;
                contractor.employmentStatus = a.employmentStatus;
                contractor.employersName = a.employersName;
                contractor.employersContactNumber = a.employersContactNumber;
                contractor.employersAddress = a.employersAddress;
                contractor.cellphone = a.cellphone;
                contractor.streetSuburb = a.streetSuburb;
                contractor.streetCity = a.streetCity;
                contractor.streetProvince = a.streetProvince;
                contractor.streetCode = a.streetCode;
                contractor.postalSuburb = a.postalSuburb;
                contractor.postalCity = a.postalCity;
                contractor.postalProvince = a.postalProvince;
                contractor.postalCode = a.postalCode;
                contractor.postalCountry = a.postalCountry;
                contractor.streetCountry = a.streetCountry;
                contractor.professionalBody = a.professionalBody;
                contractor.professionalBodyRegNum = a.professionalBodyRegNum;
                contractor.consolidatedGroup = a.consolidatedGroup;
                contractor.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                contractor.groups = groups;
                contractors.push(contractor);
            });
            app.contractor = contractors;
        }
        // set notes
        if (application.notes && application.notes?.length > 0) {
            let notes = {};
            notes = [];
            application.notes.forEach(n => {
                const note = {};
                note.id = 0;
                note.note = n.note;
                notes.push(note);
            });
            app.notes = notes;
        }
        return app;
    }
    syncMapGeometries() {
        const geometries = [];
        if (this.selectedApplication !== undefined && this.selectedApplication !== null) {
            if (this.selectedApplication.applicationLines !== null && this.selectedApplication.applicationLines?.length > 0) {
                geometries.push(this.locationForm.get("polyline").value);
            }
            else if (this.selectedApplication.applicationPolygons !== null && this.selectedApplication.applicationPolygons?.length > 0) {
                geometries.push(this.locationForm.get("polygon").value);
            }
            else {
                geometries.push(this.locationForm.get("centroid").value);
            }
            if (geometries.length > 0) {
                this.mapComponent.addGeometriesOnMap(geometries, "Draw Tool Layer", true);
            }
            else {
                this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
            }
        }
    }
    subscribeToClearMapGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    // hide previous reference number
                    this.isResubmission = false;
                    this.locationForm.get(this.previousReferenceNumberFormControlName).clearValidators();
                    this.locationForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
                    this.locationForm.updateValueAndValidity();
                    this.isVerified = false;
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    setMapData() {
        const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.shape, 102100);
        const centroid = JsonUtils.fromJSON(centroidGeometryArc);
        const geometries = [];
        this.locationForm.get("centroid").setValue(centroid);
        let showPoint = true;
        if (this.selectedApplication.applicationPolygons?.length > 0) {
            showPoint = false;
            const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.applicationPolygons[0].shape, 102100);
            const polygon = JsonUtils.fromJSON(polygonGeometryArc);
            this.locationForm.get("polygon").setValue(polygon);
            this.locationForm.get("polygonDto").setValue(this.selectedApplication.applicationPolygons[0]);
            geometries.push(polygon);
        }
        else {
            this.locationForm.get("polygon").setValue(null);
            this.locationForm.get("polygonDto").setValue(null);
        }
        if (this.selectedApplication.applicationLines?.length > 0) {
            showPoint = false;
            const polylineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.applicationLines[0].shape, 102100);
            const polyline = JsonUtils.fromJSON(polylineGeometryArc);
            this.locationForm.get("polyline").setValue(polyline);
            this.locationForm.get("polylineDto").setValue(this.selectedApplication.applicationLines[0]);
            geometries.push(polyline);
        }
        else {
            this.locationForm.get("polyline").setValue(null);
            this.locationForm.get("polylineDto").setValue(null);
        }
        if (showPoint) {
            geometries.push(centroid);
        }
        this.mapComponent.addGeometriesOnMap(geometries, "Wayleave graphics", true);
    }
    initForm() {
        this.locationForm = this.aflaModuleStrategyService.form.get("locationForm");
        this.changeDetectorRefs.detectChanges();
    }
    setupSubscribers() {
        this.subscribeToClearMapGraphics();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationLocationWamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                this.selectedApplication = +this.jobId > 0 && application ? application : null;
                if (this.selectedApplication) {
                    this.setMapData();
                }
            }
        });
    }
    getLookups() {
        this.isResubmissionOptions = [
            { code: SharedConstants.YES_NO_ENUM.Yes, value: SharedConstants.YES_NO_ENUM.Yes },
            { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }
        ];
        this.repopulateForms();
    }
    isString(value) {
        return typeof value === "string";
    }
    resetAllFormGroups() {
        this.aflaModuleStrategyService.form.get(this.detailsFormFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.applicantAgentFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.professionalBodiesFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.noteFormFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.documentationFormGroupName).reset();
        this.aflaModuleStrategyService.form.reset();
        this.changeDetectorRefs.detectChanges();
    }
    repopulateForms() {
        const isResubmission = this.locationForm.get(this.isResubmissionFormControlName).value;
        const disclaimerValue = this.locationForm.get(this.acceptFormControlName).value;
        if (isResubmission === SharedConstants.YES_NO_ENUM.Yes && disclaimerValue) {
            this.isResubmission = true;
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapTools },
        { type: DatePipe },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationWamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-wams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationWamsComponent);
export { CreateApplicationLocationWamsComponent };
